import React, { useEffect } from "react";

export default function PageNotFound() {
  useEffect(() => {
    const app = document.querySelector(".App");

    app?.classList.add("pagenotfound");

    return () => {
      app?.classList.remove("pagenotfound");
    };
  }, []);

  return (
    <>
      <div className="page-not-found-container">
        <p className="page-not-found">404 </p>
        <p className="page-not-found">Page not found</p>
        <a href="/">Back to homepage</a>
      </div>
    </>
  );
}
